import Consumer from "../../../src/models/Consumer";
import { channelTypeInfo } from "../../../src/models/ChannelType";
import { C1_Consumer } from "../model/C1_Consumer";
import { C1_EloItem_PlugType, C1_EloItem_Type } from "../types/C1_EloTypes";

export const C1_INTERACTION_CONSUMER_DRAG_TYPE = "application/x-c1-interaction-consumer";

/** Returns whether a consumer may be assigned to a button in interaction mode. */
export function isAssignableInteractionConsumer(consumer: Consumer): boolean {
  if (!channelTypeInfo(consumer.channelType).canBeConnectedWithButtonChannel) return false;

  const facet = consumer.c1;
  if (!(facet instanceof C1_Consumer)) return true;
  if (facet.definition?.type === C1_EloItem_Type.FixedPower) return false;

  const plugType = facet.data.details?.plugType;
  switch (plugType) {
    case C1_EloItem_PlugType.V230:
    case C1_EloItem_PlugType.USB:
    case C1_EloItem_PlugType.LAN:
    case C1_EloItem_PlugType.LAN2:
    case C1_EloItem_PlugType.TV:
      return false;
  }
  return true;
}
